import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * The wrapper component for the Breadcrumb Items.
 *
 * @constructor
 */
const BreadcrumbsList = styled.ul`
    align-items: ${({ alignItems }) => alignItems};
    display: ${({ display }) => display};
    list-style: none;
    line-height: 1 !important;
    margin: 0;
    padding: 0;
    overflow: hidden;
`;

BreadcrumbsList.defaultProps = {
    alignItems: null,
    display: null,
};

BreadcrumbsList.propTypes = {
    alignItems: PropTypes.string,
    display: PropTypes.string,
};

export default BreadcrumbsList;
